export enum BuilderTypes {
    Flow = "Flow",
    Form = "Form",
    StatementRule = "Statement Rule",
    IntersectionRule = "Intersection Rule",
    RuleTable = "Rule Table",
    ValueTable = "Value Table",
    TreeRule = "Tree Rule",
    DataMapping = "Data Mapping",
    DataDefinition = "Data Definition",
    TextMerge = "Text Merge",
    Other = "Other",
    UnitTest = "Unit Test",
    SampleData = "Sample Data",
    RuleSetData = "Rule Set Data",
}
